<template>
    <form-row title="Purchase Price">
        <input-money
            :value="property.purchase_price"
            name="purchase_price"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        property: {},
        read_only: { default: false },
    },
}
</script>
